import { auth } from '../firebase';
import { BrowserSettings, BrowserSettingsUpdate } from '../types/browserSettings';

const API_BASE_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/api`;

class BrowserSettingsService {
  private async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const user = auth.currentUser;
    if (!user) {
      throw new Error('User not authenticated');
    }
    const token = await user.getIdToken();

    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        ...options.headers,
      },
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ detail: 'Request failed' }));
      throw new Error(error.detail || 'Request failed');
    }

    return response.json();
  }

  /**
   * Get the Browser settings of a device. Rejects on failure: the card shows a load error
   * rather than a switch whose value is not known.
   */
  async getSettings(deviceId: string): Promise<BrowserSettings> {
    return this.request<BrowserSettings>(`/devices/${deviceId}/browser-settings/`);
  }

  /**
   * Update the Browser settings of a device. Only the provided keys change.
   */
  async updateSettings(
    deviceId: string,
    updates: BrowserSettingsUpdate
  ): Promise<BrowserSettings> {
    return this.request<BrowserSettings>(`/devices/${deviceId}/browser-settings/`, {
      method: 'PUT',
      body: JSON.stringify(updates),
    });
  }
}

export const browserSettingsService = new BrowserSettingsService();
